// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { Card, Grid, Typography } from '../base';

export default function Error404() {
  return (
    <div>
      <Helmet>
        <title>{'404'}</title>
      </Helmet>
      <Grid sx={{ p: 2 }} container justifyContent="center" columns={{ xs: 4, sm: 8, md: 12 }}>
        <Grid size={{ xs: 12, md: 8, lg: 4 }}>
          <Card
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              padding: 4,
              textAlign: 'center',
            }}
          >
            <Typography variant="h4" sx={{ pb: 6 }}>
              Sorry, that page was not found.
            </Typography>
            <Typography variant="subtitle1">Try going back to where you were or heading to the home page.</Typography>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}
